<template>
  <div class="archive-wrapper">
    <div class="spinner-container" v-if="isLoading">
      <base-spinner :is-loading="true" :is-local="true" class="spinner" />
    </div>
    <BorrowerArchive v-if="!isLoading && profile.role === 'borrower'" />
    <LenderArchive v-if="!isLoading && profile.role === 'lender'" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseSpinner from '../../components/base/BaseSpinner.vue';
import BorrowerArchive from './BorrowerArchive.vue';
import LenderArchive from './LenderArchive.vue';

export default {
  name: 'Archive',
  components: {
    BaseSpinner,
    BorrowerArchive,
    LenderArchive
  },
  async created() {
    await this.$store.dispatch('updateProfile');
    const { loansParams, loansFilter } = this.$route.params || {};

    await this.$store.dispatch('getLoansArchivedList', {
      ...(loansParams || this.params),
      filter: loansFilter
    });

    if (this.profile.role === 'lender') {
      await this.$store.dispatch('getOffersArchivedList', { ...this.params });
    }

    this.isLoading = false;
  },
  data() {
    return {
      isLoading: true,
      params: {
        page: 0,
        size: 10
      }
    };
  },
  computed: {
    ...mapGetters(['profile'])
  }
};
</script>

<style lang="scss" scoped>
.archive-wrapper {
  @include page-wrapper-with-header-and-footer;

  padding-top: 20px;
  box-sizing: border-box;
  background-color: var(--profile-page-bgc);
}

.spinner-container {
  @include base-page-container;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 10%;
  color: var(--profile-text-color);
}

.spinner ::v-deep {
  width: 100%;
}
</style>
